import React, { useState, useEffect, useRef } from "react";
import NoteIcon from "./img/note2.webp";
import { Button, Form, Row, Col, Modal } from "react-bootstrap";
import NotizArtenTabs from "./NotizArtenTabs";
import { notizarten, notizfarben } from "./globalVariables";
import { useConfig } from "./ConfigContext";
import { formatText } from "./formatFunctions";

const initialNote = { text: "", type: {}, active: 0 };
export default function KachelNotizMenu({
   kachelData,
   handleElementBlock,
   currentElement,
   blockedField,
   estateId,
   user,
   notizen,
   sendCommentsandNotes,
   loading,
}) {
   const config = useConfig();
   const [showNotes, setShowNotes] = useState(false);
   const [newNote, setNewNote] = useState(false);
   const [note, setNote] = useState(initialNote);
   const [selectedNotizart, setSelectedNotizart] = useState("Alle");

   function closeModal() {
      setShowNotes(false);
      handleElementBlock(false, config.estate.notiz, notizen);
   }

   return (
      <>
         <button
            className="share-button"
            style={blockedField[config.estate.notiz] ? { opacity: 1, outline: "solid 6px #f0a" } : {}}
            title="Notiz anzeigen/verbergen"
            onClick={(e) => {
               e.preventDefault();
               console.log(notizen[kachelData.kachelId]);

               setShowNotes(true);
            }}
         >
            <img src={NoteIcon} />
            {blockedField[config.estate.notiz] ? (
               <span style={{ backgroundColor: "#f0a" }}>{blockedField[config.estate.notiz].user.Kuerzel}</span>
            ) : (
               <>
                  {notizen[kachelData.kachelId] && notizen[kachelData.kachelId].length && (
                     <>
                        {notizarten.map((item) => {
                           if (notizen[kachelData.kachelId].filter((notizitem) => notizitem.type[item.value]).length) {
                              return (
                                 <span style={{ backgroundColor: notizfarben[item.value] }}>
                                    {
                                       notizen[kachelData.kachelId].filter(
                                          (notizitem) =>
                                             notizitem.type[item.value] && notizitem.type[item.value].active,
                                       ).length
                                    }
                                    {item.name[0]}
                                 </span>
                              );
                           }
                        })}
                     </>
                  )}
               </>
            )}
         </button>

         <Modal show={showNotes} size="xl" className="" onHide={() => closeModal()}>
            <Modal.Header closeButton>
               <h3>
                  <img className="me-3" src={NoteIcon} height={36} />
                  Notizen
                  {blockedField[config.estate.notiz] && (
                     <small style={{ color: "#f0a" }}>
                        {" "}
                        ... wird aktuell bearbeitet von {blockedField[config.estate.notiz].user.Name}
                     </small>
                  )}
               </h3>
            </Modal.Header>
            <Modal.Body>
               <NotizArtenTabs selectedNotizart={selectedNotizart} setSelectedNotizart={setSelectedNotizart} />
               <div
                  className="kachel-notizbereich"
                  style={
                     blockedField[config.estate.notiz]
                        ? { pointerEvents: "none", opacity: 0.9, filter: "saturate(0)" }
                        : {}
                  }
                  onClick={() => {
                     console.log("click");
                     if (!currentElement.element || currentElement.element !== config.estate.notiz) {
                        handleElementBlock(true, config.estate.notiz, notizen);
                     }
                  }}
               >
                  {notizen[kachelData.kachelId] &&
                     notizen[kachelData.kachelId]
                        .filter((notizitem) => selectedNotizart === "Alle" || notizitem.type[selectedNotizart])
                        .map((notiz, index) => (
                           <>
                              <div
                                 key={"kachel-notiz" + index}
                                 className="kachel-notiz "
                                 style={{ paddingTop: "5px", opacity: notiz.active ? 1 : 0.1 }}
                              >
                                 <small style={{ color: "#333" }}>
                                    {notiz.bearbeitet && (
                                       <span>
                                          <strong>bearbeitet</strong>
                                       </span>
                                    )}{" "}
                                    von {notiz.user} {new Date(notiz.timestamp).toLocaleString()}
                                 </small>
                                 <div className="kachel-notiz-body">
                                    <p>
                                       {formatText(notiz.text)}{" "}
                                       <button
                                          style={{
                                             borderRadius: "22px",
                                             color: "#fff",
                                             border: "none",
                                             padding: "0px 4px",
                                             backgroundColor: "#224",
                                          }}
                                          className="me-2"
                                          onClick={() => {
                                             setNewNote(true);
                                             setNote({ ...notiz, bearbeitet: true, index: index });
                                          }}
                                       >
                                          ✎
                                       </button>
                                    </p>
                                 </div>
                              </div>
                           </>
                        ))}
                  {!newNote && (
                     <Button variant="dark" className="mt-2 px-5" onClick={() => setNewNote(true)}>
                        + Neue Notiz{"⠀"}
                     </Button>
                  )}

                  {newNote && (
                     <>
                        <hr />
                        <hr />
                        <h4>Notiz</h4>
                        <Form.Group className="mb-3" as={Col}>
                           <Form.Control
                              required
                              as="textarea"
                              placeholder=""
                              onChange={(e) => setNote((prev) => ({ ...prev, text: e.target.value }))}
                              value={note.text ? note.text : ""}
                              style={{ minHeight: "160px", fieldSizing: "content" }}
                           />
                        </Form.Group>
                        <p>Notizart</p>
                        <Row>
                           {notizarten.map((notizart) => (
                              <label className="checkbox-container col mb-5">
                                 <input
                                    type="checkbox"
                                    id={"check_" + notizart.value}
                                    name={notizart.value}
                                    checked={note.type[notizart.value] ? note.type[notizart.value].active : ""}
                                    onChange={(e) => {
                                       let cloneNote = structuredClone(note);

                                       console.log(cloneNote);
                                       if (e.target.checked) {
                                          cloneNote.type[notizart.value] = { active: true };
                                       } else {
                                          delete cloneNote.type[notizart.value];
                                       }

                                       console.log(cloneNote);

                                       setNote(cloneNote);
                                    }}
                                 />
                                 {notizart.name}
                              </label>
                           ))}
                        </Row>

                        <Button
                           variant="dark"
                           disabled={!Object.keys(note.type).length || loading === "loading"}
                           onClick={async () => {
                              await sendCommentsandNotes(
                                 "note",
                                 kachelData.kachelId,
                                 {
                                    text: note.text,
                                    type: note.type,
                                    timestamp: new Date().toISOString(),
                                    user: user.Name,
                                    active: Object.keys(note.type).length,
                                    bearbeitet: note.bearbeitet,
                                 },
                                 note.bearbeitet ? note.index : undefined,
                              );
                              setNote(initialNote);
                              setNewNote(false);
                           }}
                        >
                           Speichern
                        </Button>
                        <span className="ms-2">(Mindestens eine Notizart ist Pflicht)</span>
                     </>
                  )}
               </div>
            </Modal.Body>
         </Modal>
      </>
   );
}
